import { nl } from "vuetify/locale";

export default {
    ...nl,

    "alert": "Alert",
    "add": "Toevoegen",
    "back": "Terug",
    "cancel": "Annuleren",
    "clear": "Alles verwijderen",
    "close": "Sluiten",
    "confirm": "Bevestigen",
    "next": "Volgende",
    "save": "Opslaan",
    "send_email": "Stuur e-mail",
    "help_country_code": "Landcode",
    "help_search_country": "Zoek een land",
    "help_mobile_number": "Mobiel Nummer",
    "help_example": "Voorbeeld",
    "earned": "Verwezenlijkt",
    "info": "Info",
    "ingredients": "Ingrediënten",
    "info_nutritional": "Voedingswaarde-informatie",
    "remove": "Verwijderen",
    "removeall": "Verwijder Alles",

    "campaigns": "Campagnes",
    "highlights": "Hoogtepunten",
    "home": "Home",
    "items": "Artikelen",
    "map": "Kaart",
    "address": "Adres",
    "settings": "Instellingen",
    "store": "Winkel",
    "stores": "Vind Ons",
    "support": "Ondersteuning",
    "user": "Profiel",
    "offers": "Promoties",
    "qrcode": "qrcode",
    "transactions": "Bewegingen",

    "generic_error": "Informatie momenteel niet beschikbaar",
    "mandatory": "Verplicht",
    "missing": "Missend",
    "no_movements_to_display": "Er zijn nog geen bewegingen gemaakt",
    "phone_number": "Telefoonnummer",
    "points": "Punten",
    "qrcode_show_message": "Laat deze code in de winkel zien",
    "stores_not_available": "Não há Lojas Disponíveis",
    "total": "Totaal",
    "thank_you": "Obrigado!",
    "transactions_detail": "Detail",
    "user_profile_updated_success": "Gebruikersprofiel succesvol bijgewerkt",
    "user_welcome": "Hallo",

    "id_document": "Nummer",
    "id_document_type": "Identificatiedocument",

    "profile": {
        "birth_date": "Geboortedatum",
        "birth_date_required": "Geboortedatum vereist",
        "birth_date_minors": "Ongeldige geboortedatum, minderjarigen zijn uitgesloten",
        "citizen_card_size": "Moet 12 cijfers zijn",
        "communication_preferences": "Communicatie voorkeuren",
        "email_required": "E-mail is vereist",
        "email_invalid": "Email is ongeldig",
        "favourite_store": "Favoriete winkel",
        "gender": "Geslacht",
        "gender_male": "Mannelijk",
        "gender_female": "Vrouwelijk",
        "gender_other": "Anders",
        "gender_required": "Geslacht is vereist",
        "id_document_required": "Verplicht identificatiedocumentnummer",
        "id_document_type_empty": "U moet het type document selecteren",
        "identity_card_size": "Moet 9 cijfers zijn",
        "name": "Naam",
        "name_invalid": "Naam moet minder dan 20 tekens bevatten",
        "name_invalid_two_names": "Voor- en achternaam",
        "name_required": "Naam is vereist",
        "number_invalid": "Ongeldig nummer",
        "passport_size": "Moet 8 cijfers zijn",
        "phone_number_required": "Mobiel nr. is vereist",
        "phone_nine_digits": "Mobiel nr. moet 9 cijfers bevatten",
        "tax_number": "Tax nummer",
        "tax_number_nine_digits": "Tax nummer moet 9 cijfers bevatten",
        "tax_number_invalid": "Ongeldig tax nummer",
    },

    "gdpr_agreement": {
        "agreement_mandatory": "U moet akkoord gaan om door te gaan",
        "agreement_communication_means_mandatory": "Om door te gaan, moet u een communicatiemiddel accepteren",
        "gdpr_agreement": "Voorwaarden",
        "gdpr_agreement_accept": "Ik heb de Algemene voorwaarden gelezen en ga hiermee akkoord, evenals de bescherming van persoonlijke gegevens.",
        "gdpr_agreement_agree": "Mee eens",
        "gdpr_agreement_disagree": "Het oneens zijn",
        "program_terms_policy": "Algemene voorwaarden",
        "terms_policy": "Voorwaarden en Privacybeleid",
        "gdpr_agreement_revoke": "De toestemming om persoonlijke gegevens te registreren is met succes ingetrokken. Uw gegevens worden verwijderd."
    },

    "authentication": {
        "login_error": "Het was niet mogelijk om de aangeduide code en gebruiker te valideren",
        "end_session": "Sessie beëindigd",
        "login_step_user_title": "Vul je mobiele telefoonnummer in",
        "login_step_user_subtitle": "Als je nog niet geregistreerd bent, sturen we je een sms met een code om je registratie te voltooien",
        "login_step_password_title": "Voer uw toegangscode in",
        "login_step_newuser_password_subtitle": "Controleer de toegangscode in de sms die naar u is verzonden. Deze code is vereist om opnieuw te verifiëren. U kunt dit in uw profiel wijzigen nadat u zich heeft aangemeld.",
        "logout": "Uitloggen",
        "new_register": "Nieuwe registratie",
        "password": "Paswoord",
        "password_change": "Verander Paswoord",
        "password_old": "Oude Paswoord",
        "password_new": "Nieuwe Paswoord",
        "password_new_success_sent": "Nieuwe toegangscode succesvol verzonden naar uw mobiele telefoon",
        "password_bigger_than8": "Moet minstens 9 tekens bevatten",
        "password_bigger_than10": "Moet minstens 10 tekens bevatten",
        "password_lower_case": "Moet minstens 1 kleine letter bevatten;",
        "password_one_number": "Moet minstens 1 cijfer bevatten.",
        "password_special_char": "Deve incluir um caracter especial.",
        "password_upper_case": "Moet minstens 1 hoofdletter bevatten;",
        "password_recover": "Stuur nieuwe paswoord",
        "password_required": "Paswoord is vereist",
        "username_nine_digits": "Mobiel nr. moet 9 cijfers bevatten",
        "phone_number_invalid": "Mobiel nr. ongeldig",
        "password_change_success": "Paswoord succesvol gewijzigd."
    },

    "vouchers": {
        "vouchers": "Vouchers",
        "voucher_due_date": "Opleveringsdatum",
        "voucher_available_at": "Geldig op",
        "voucher_emitted": "Afgegeven voucher",
        "voucher_offers": "Vouchers en aanbiedingen",
        "voucher_rescued": "Ingewisselde voucher",
    },

    "shop": {
        "shop_cart": "Winkelmand",
        "shop_cart_pay": "Pagamento",
        "shop_cart_checkout": "Volgende",
        "shop_cart_submit": "Uitchecken",
        "shop_cart_items": "Artikelen in winkelwagen",
        "shop_cart_empty": "Uw winkelwagen is leeg",
        "shop_cart_items_unavailable": "Sommige artikelen in de winkelwagen zijn momenteel niet beschikbaar.",
        "shop_item_added_to_cart": "Het artikel is succesvol aan de winkelwagen toegevoegd",
        "shop_item_remove_from_cart": "Artikel succesvol verwijderd uit de winkelwagen",
        "shop_item_stock": "Beschikbaar",
        "shop_item_nostock": "Geen voorraad",
        "order_successfully_submited": "Bestelling succesvol ingediend",
        "buy": "Kopen",
        "payment_method": "Método de Pagamento",
        "shipping_costs": "Bezorgkosten",
        "shipping_method": "Bezorgoptie",
        "shipping_location": "Ophaalplaats",
        "my_orders": "Mijn bestellingen",
        "catalog": "Winkel",
        "order_resume_comments": "Opmerkingen",
        "order_resume_choose_date": "Kies een Datum",
        "delivery_options": "Bezorgopties",
        "delivery_not_available": "Delivery Options Not Available",
        "order_resume": "Bevestiging afrekenen",
        "order_pay": "Pagamento",
        "order_payment_entity": "Entidade",
        "order_payment_reference": "Referência",
        "order_payment_value": "Valor",
        "order_payment_success": "Pagamento Verificado com Sucesso",
        "order_payment_pending": "A Aguardar Validação do Pagamento",
        "order_payment_error": "Não foi possível validar o Pagamento",
        "order_complete": "Encomenda Finalizada com Sucesso!",
        "exceeded_daily_orders": "Maximaal toegestane limiet voor bestellingsverzoeken overschreden",
        "item_details_view": "Details",
        "item_define_menu": "O Meu Menu",
        "item_define_menu_extra": "Options",
        "remember_orders_in_progress": "Controleer de status van uw bestelling",
        "remember_shop_cart": "Uw winkelwagen wacht",
        "promo_valid_until": "Promotie geldig tot",
    },

    "id_document_types": {
        "citizen_card": "Burgerkaart",
        "identity_card": "Identiteitskaart",
        "passport": "Paspoort",
        "residence_permit": "Verblijfsvergunning",
    },

    "qr_scanner": {
        "scan_qr_code": "Scan QR-code",
        "camera_denied": "Cameratoegang is geweigerd. Geef cameratoegang.",
        "camera_not_found": "Geen camera gevonden op dit apparaat.",
        "camera_in_use": "Camera wordt al gebruikt door een andere applicatie.",
        "camera_not_supported": "Camera wordt niet ondersteund op dit apparaat.",
        "camera_error": "Camera fout: ",
        "scanned_document": "Gescand Document",
        "document_number": "Documentnummer",
        "date": "Datum",
        "total": "Totaal",
        "qr_code_data": "QR-code gegevens",
        "parse_error": "Kon ATCUD-formaat niet parseren. Ruwe data:",
        "no_data": "Geen QR-code gegevens ontvangen.",
        "add_purchase": "Aankoop toevoegen",
        "purchase_added": "Aankoop succesvol toegevoegd",
        "purchase_error": "Er is een fout opgetreden bij het toevoegen van de aankoop",
    }
}
